import { z } from "zod";
var PRODUCT_NAME = /* @__PURE__ */ ((PRODUCT_NAME2) => {
  PRODUCT_NAME2["MEMBERSHIP_19_99_EUR_QUARTERLY"] = "membership_19_99_eur_quarterly";
  PRODUCT_NAME2["MEMBERSHIP_19_99_EUR_ANNUALLY"] = "membership_19_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_19_99_EUR_SINGLE"] = "membership_19_99_eur_single";
  PRODUCT_NAME2["MEMBERSHIP_9_99_EUR_ANNUALLY"] = "membership_9_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_BIDROOM_19_99_EUR_ANNUALLY"] = "membership_bidroom_19_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_COMPLETE_49_99_EUR_ANNUALLY"] = "membership_complete_49_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_COMPLETE_49_99_EUR_SINGLE"] = "membership_complete_49_99_eur_single";
  PRODUCT_NAME2["MEMBERSHIP_COMPLETE_64_99_EUR_ANNUALLY"] = "membership_complete_64_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_ESSENTIAL_19_99_EUR_ANNUALLY"] = "membership_essential_19_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_ESSENTIAL_19_99_EUR_SINGLE"] = "membership_essential_19_99_eur_single";
  PRODUCT_NAME2["MEMBERSHIP_ESSENTIAL_24_99_EUR_SINGLE"] = "membership_essential_24_99_eur_single";
  PRODUCT_NAME2["MEMBERSHIP_ESSENTIAL_22_49_EUR_SINGLE"] = "membership_essential_22_49_eur_single";
  PRODUCT_NAME2["MEMBERSHIP_ESSENTIAL_24_99_EUR_ANNUALLY"] = "membership_essential_24_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_TELEMEDICO_19_99_EUR_ANNUALLY"] = "membership_telemedico_19_99_eur_annually";
  PRODUCT_NAME2["MEMBERSHIP_9_99_EUR_SINGLE"] = "membership_9_99";
  PRODUCT_NAME2["MEMBERSHIP_FREE"] = "membership_free";
  PRODUCT_NAME2["MEMBERSHIP_FREEMIUM"] = "membership_freemium";
  PRODUCT_NAME2["MEMBERSHIP_COMPLETE_INTERNAL"] = "membership_complete_internal";
  PRODUCT_NAME2["MEMBERSHIP_COMPLETE_EXTERNAL"] = "membership_complete_external";
  PRODUCT_NAME2["AIRHELP_SMART_SINGLE"] = "airhelp_smart_single";
  PRODUCT_NAME2["AIRHELP_SMART_ANNUALLY"] = "airhelp_smart_annually";
  PRODUCT_NAME2["AIRHELP_PRO_ANNUALLY"] = "airhelp_pro_annually";
  PRODUCT_NAME2["AIRHELP_LITE_ANNUALLY"] = "airhelp_lite_annually";
  PRODUCT_NAME2["AIRHELP_PRO_INTERNAL"] = "airhelp_pro_internal";
  PRODUCT_NAME2["AIRHELP_PRO_EXTERNAL"] = "airhelp_pro_external";
  PRODUCT_NAME2["TRIP"] = "trip";
  PRODUCT_NAME2["TRIP_ESSENTIAL"] = "trip_essential";
  PRODUCT_NAME2["TRIP_COMPLETE"] = "trip_complete";
  PRODUCT_NAME2["KIWI_AHPLUS"] = "kiwi_ahplus";
  PRODUCT_NAME2["KIWI_AIR_LUGGAGE"] = "kiwi_air_luggage";
  PRODUCT_NAME2["KIWI_AHPLUS_AIR_LUGGAGE"] = "kiwi_ahplus_air_luggage";
  PRODUCT_NAME2["AGODA_AHPLUS_AIR_PAYOUT"] = "agoda_ahplus_air_payout";
  PRODUCT_NAME2["UPGRADE_TO_TRIP_COMPLETE"] = "upgrade_to_trip_complete";
  PRODUCT_NAME2["TEST_MEMBERSHIP"] = "test_membership";
  PRODUCT_NAME2["JUMPEOPLE_AHPLUS_LOUNGE_AIR_PAYOUT_AIR_LUGGAGE_020624"] = "jumpeople_ahplus_lounge_air_payout_air_luggage_020624";
  PRODUCT_NAME2["MICROSIGNALS_AHPLUS_010624"] = "microsignals_ahplus_010624";
  PRODUCT_NAME2["MICROSIGNALS_AHPLUS_AIR_LUGGAGE_010624"] = "microsignals_ahplus_air_luggage_010624";
  PRODUCT_NAME2["IN_SURE_BROKER_AHPLUS_240624"] = "in_sure_broker_ahplus_240624";
  PRODUCT_NAME2["IN_SURE_BROKER_AHPLUS_LOUNGE_240624"] = "in_sure_broker_ahplus_lounge_240624";
  PRODUCT_NAME2["JUMPEOPLE_AHPLUS_020624"] = "jumpeople_ahplus_020624";
  return PRODUCT_NAME2;
})(PRODUCT_NAME || {});
var PAYMENT_FREQUENCY = /* @__PURE__ */ ((PAYMENT_FREQUENCY2) => {
  PAYMENT_FREQUENCY2["NONE"] = "none";
  PAYMENT_FREQUENCY2["SINGLE"] = "single";
  PAYMENT_FREQUENCY2["QUARTERLY"] = "quarterly";
  PAYMENT_FREQUENCY2["ANNUALLY"] = "annually";
  return PAYMENT_FREQUENCY2;
})(PAYMENT_FREQUENCY || {});
var PRODUCT_PERK = /* @__PURE__ */ ((PRODUCT_PERK2) => {
  PRODUCT_PERK2["ESIM"] = "Esim";
  PRODUCT_PERK2["AIR_PAYOUT"] = "AirPayout";
  PRODUCT_PERK2["AIR_LUGGAGE"] = "AirLuggage";
  PRODUCT_PERK2["AIRPORT_TRANSFER"] = "AirportTransfer";
  PRODUCT_PERK2["LOUNGE_ACCESS"] = "LoungeAccess";
  PRODUCT_PERK2["CAR_RENTAL"] = "CarRental";
  PRODUCT_PERK2["FLIGHT_NOTIFICATION"] = "FlightNotification";
  PRODUCT_PERK2["JOURNEY_LOUNGE_ACCESS"] = "JourneyLoungeAccess";
  return PRODUCT_PERK2;
})(PRODUCT_PERK || {});
const ProductDisplayName = z.enum([
  "AirHelp+ with Lounges and AirLuggage",
  "AirHelp+ with AirLuggage and AirPayout",
  "AirHelp+",
  "AirHelp+ Essential",
  "AirHelp+ Complete",
  "AirHelp+ free",
  "AirHelp+ freemium",
  "AirHelp+ Luggage",
  "AirHelp Plus",
  "Air Luggage",
  "AirHelp Plus Air Luggage",
  "AirHelp Plus Air Payout",
  "AirHelp+ Complete Employee",
  "AirHelp+ Pro",
  "AirHelp+ Smart",
  "AirHelp+ Lite",
  "AirHelp+ Pro Employee",
  "AirHelp+ Lounge",
  "AirHelp+ with AirLuggage",
  "AirHelp+ with AirPayout",
  "AirHelp+ with Lounges",
  "AirHelp+ Lounge Luggage",
  "Upgrade to Trip Complete"
]);
const MembershipTier = z.enum([
  "complete",
  "essential",
  "lite",
  "pro",
  "smart"
]);
const TripTier = z.enum(["complete", "essential"]).nullable();
export {
  MembershipTier as M,
  PRODUCT_NAME as P,
  TripTier as T,
  PAYMENT_FREQUENCY as a,
  PRODUCT_PERK as b,
  ProductDisplayName as c
};
//# sourceMappingURL=types-BlLW4vek.js.map
